import { BaseModel } from "models"
import { Infraction } from "./infraction.model"

export class InterviewSkillControl extends BaseModel<InterviewSkillControl> {
  maxValue: number
  state: string
  skillId: number
  skillName: string
  _destroy: boolean
}

export class InterviewSkillValue extends BaseModel<InterviewSkillValue> {
  value: number
  skillId: number
  skillName: string
  maxValue: number
}

export class InterviewResultInfraction extends BaseModel<InterviewResultInfraction> {
  detected: boolean
  selectedReasonId: number
  infractionId: number
  infraction: Infraction

  get infractionName(): string {
    return this.infraction && this.infraction.name
  }

  get infractionValue(): string {
    if (!this.infraction) {
      return null
    }

    if (this.infraction.isReasonable) {
      let reason = this.selectedReasonId && this.infraction.reasons.find(r => r.id == this.selectedReasonId)
      return reason ? reason.name : "Не выбрано"
    }

    return this.detected ? "Да" : "Нет"
  }
}

export class InterviewResult extends BaseModel<InterviewResult> {
  callDuration: number
  dialingTime: number
  closingSessionTime: number
  resolution: string
  extraResolutions: {}
  skillValues: InterviewSkillValue[]
  resultInfractions: InterviewResultInfraction[]
}

export class Interview extends BaseModel<Interview> {

  static DEFAULT_ATTRIBUTES = {
    skillControls: [],
    infractionIds: [],
    infractions: []
  }

  comment: string
  folderId: number
  name: string
  state: string
  skillControls: InterviewSkillControl[]
  infractionIds: number[]
  infractions: Infraction[]

  removed(): boolean {
    return this.state == 'removed'
  }

  disabled(): boolean {
    return this.state == 'disabled'
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/models/interview.model.ts